const COOKIE_TOKEN_NAME = 'token';

export default class CookieHandler {

    static updateTokenCookie(token) {
        CookieHandler.setCookie(COOKIE_TOKEN_NAME, token, 1);
    }

    static setCookie(cookieName, cookieValue, expirationDays = 1) {
        const currentDate = new Date();

        currentDate.setTime(currentDate.getTime() + (expirationDays * 24 * 60 * 60 * 1000));

        const expires = `expires=${currentDate.toUTCString()}`;
        window.document.cookie = `${cookieName}=${cookieValue}; ${expires}; path=/`;
    }

    static clearTokenCookies() {
        const cookies = window.document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if (name && (name.trim() === COOKIE_TOKEN_NAME)) {
                window.document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
            }
        }
    }

    static getTokenCookie() {
        return CookieHandler.getCookie(COOKIE_TOKEN_NAME);
    }

    static getCookie(cookieName) {
        const name = `${cookieName}=`;
        const cookies = window.document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let cookieItem = cookies[i];
            while (cookieItem.charAt(0) === ' ') {
                cookieItem = cookieItem.substring(1);
            }
            if (cookieItem.indexOf(name) === 0) {
                return cookieItem.substring(name.length, cookieItem.length);
            }
        }

        return '';
    }
}



// WEBPACK FOOTER //
// ./src/services/CookieHandler.js